import _ from "lodash";
import React from "react";
import classes from "./JournalFeed.scss";
import { graphql, compose } from "lib/apolloClient";
import { connect } from "react-redux";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import I18nHOC from "UIComponents/I18nHOC";
import withPusherBind from "UIComponents/PusherConsumerHoc";
import EmptyView from "UIComponents/EmptyView/EmptyView";
import {
  getCoursePostFeedQuery,
  getParentJournalFeedQuery,
} from "Post/modules/PostQuery";
import {
  getCourseJournalFeedFromCache,
  getParentJournalFeedFromCache,
} from "Post/modules/PostGraphqlHelpers";
import { PostCard, SubjectJournalCard } from "Post";
import classNames from "classnames";
import { checkScrollAtBottom } from "Utils";
import ActionBar from "../ActionBar";
import ActionBarV2 from "../ActionBarV2";
import {
  checkPostDetailsVisibilityPermission,
  hasTranslationPermission,
  getPostTranslationFilter,
  isDPSubjectJournalEnabled,
  isPortfolioParityEnabled,
  isPortfolioFilterRevamp,
  isPortfolioReviewSetupEnabled,
  isPortfolioReviewSetupEnabledAndIsJournalRoute,
  canManagePortfolioActions,
} from "Post/utils";
import HiddenIfPreviousYear from "AppComponents/HiddenIfPreviousYear";
import { getFieldUidsMemoize } from "modules/TaggableElementsUtils";
import { setActiveHomepageCard } from "Teacher/modules/TeacherModule";
import { getSettingValue } from "modules/PermissionModule";
import { EmptyState } from "@toddle-edu/ds-web";
import {
  EvidenceIllustration,
  NoFilterResultIllustration,
  NoSearchInFilterIllustration,
} from "@toddle-edu/ds-theme";
import {
  getPostFeedFiltersMemoized,
  getTagsMemoized,
} from "../../modules/Utils";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { CURRICULUM_TYPE_DP } from "Constants/stringConstants";

import { bulkPostsDraftOrPublishAction } from "Journal/modules/JournalModule";
import SearchWithFilters from "../SearchWithFilters/SearchWithFilters";
import ApproveActionBar from "./components/ApproveActionBar";
import CardSkeletonLoader from "./components/CardSkeletonLoader";
import moment from "moment";

const LoadingStyle = {
  width: 24,
  height: 24,
};

const alertStyle = {
  width: "570px",
  left: "48%",
};
const BLANK_OBJECT = {};

const JournalFeedComponent = ({
  feedList,
  onPostActionClick,
  userInfo,
  currentCommentPostId,
  isArchivedClass,
  isDPFeedView = false,
  showCommentButton,
  networkStatus,
  isStudentArchived,
  isUserAllowedToPublishPost,
  isPostCtaDisabled,
}) => {
  const { id: userId, user_type: userType } = userInfo;
  const hasManageAccess = canManagePortfolioActions(userType);
  // Filter out only permitted posts
  const updatedFeedList = _.filter(feedList, item => {
    return checkPostDetailsVisibilityPermission({
      userInfo,
      postDetails: item.node,
    });
  });
  return (
    <div className={classes.centerContainer}>
      {/* A student can edit or delete its own post but teacher can do to any post   */}
      {/* Normal journal post cards (PYP, MYP, UbD) */}
      {!isDPFeedView &&
        _.map(updatedFeedList, item => {
          return (
            <PostCard
              key={item?.node?.id}
              item={item.node}
              onPostActionClick={onPostActionClick}
              userId={userId}
              currentCommentPostId={currentCommentPostId}
              canEditOrDelete={
                userType == "staff" ||
                userId == _.get(item, "node.createdBy.id")
              }
              isArchivedClass={isArchivedClass}
              isUserAllowedToPublishPost={isUserAllowedToPublishPost}
              isPostCtaDisabled={isPostCtaDisabled}
            />
          );
        })}

      {isDPFeedView &&
        _.map(updatedFeedList, item => {
          // Card for DP journal Feed
          return (
            <SubjectJournalCard
              key={item?.node?.id}
              post={item?.node}
              onPostActionClick={onPostActionClick}
              userId={userId}
              canEditOrDelete={
                userType == "staff" ||
                userId == _.get(item, "node.createdBy.id")
              }
              isArchivedClass={isArchivedClass}
              showCommentButton={showCommentButton}
              isStudentArchived={isStudentArchived}
              hideMoveToDraftOption={
                _.get(item, "node.createdBy.type", "staff") === "student"
              }
              currentCommentPostId={currentCommentPostId}
              isUserAllowedToPublishPost={isUserAllowedToPublishPost}
              isPostCtaDisabled={isPostCtaDisabled}
              hasManageAccess={hasManageAccess}
            />
          );
        })}
      <LoadingComponent networkStatus={networkStatus} />
    </div>
  );
};

const JournalFeedComponentWithLoader = compose(withLoader)(
  JournalFeedComponent
);

const LoadingComponent = ({ networkStatus }) => {
  return (
    <div className={classes.loadingContainer}>
      {networkStatus == 3 ? <Loading loadingStyle={LoadingStyle} /> : null}
    </div>
  );
};

const NoDataComponent = ({ filters, t, userType, reset }) => {
  let emptyText = ``;
  let title =
    filters.state === "IN_APPROVAL"
      ? t("journal:review_student_posts")
      : filters.state === "DRAFT"
      ? t("journal:view_draft_posts_here")
      : t("journal:nothing_here_yet");
  let illustration = EvidenceIllustration;
  const isFilterApplied =
    !_.isEmpty(filters.duration) ||
    !_.isEmpty(filters.searchText) ||
    !_.isEmpty(filters.folderIds);
  if (filters.state == "IN_APPROVAL") {
    // Show empty text in in-approval based on user type
    emptyText =
      userType == "student"
        ? t("journal:no_feed_button_label", {
            buttonName: t("journal:createPost"),
          })
        : t("post_submitted_by_student_will_appear_here_for_review");
  } else if (userType === "parent") {
    emptyText = t("journal:no_post_created_yet");
  } else if (userType === "staff" && filters.state === "IN_APPROVAL_STAFF") {
    title = t("journal:no_post_for_review_title");
    emptyText = t("journal:no_post_for_review_subtitle");
  } else if (filters.state === "DRAFT") {
    emptyText = t("journal:draft_posts_saved_will_appear_here");
  } else {
    emptyText = t("journal:no_feed_button_label", {
      buttonName: t("journal:createPost"),
    });
  }

  const isDurationFilterApplied = !_.isEmpty(_.get(filters, "duration", {}));
  if (isDurationFilterApplied) {
    illustration = NoSearchInFilterIllustration;
    title = t("common:noResultHeading");
    emptyText = t("common:student_search_empty_state_description");
  }

  if (isFilterApplied && isPortfolioFilterRevamp()) {
    return (
      <EmptyView
        buttonVariant="outlined"
        buttonText={`${t("common:reset")}`}
        showButton
        emptyImageUrl={NoFilterResultIllustration}
        size={"large"}
        emptyHeaderText={`${t("journal:no_posts_found")}`}
        emptyText={t("journal:please_try_modifying_your_search_or_filters")}
        onButtonClick={reset}
      />
    );
  }

  return (
    <div className={classes.emptyState}>
      <EmptyState
        illustration={illustration}
        title={title}
        subtitle={emptyText}
      />
    </div>
  );
};

class JournalFeed extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showActionBar: true,
      showDateRangeModal: false,
    };
  }

  componentDidMount = () => {
    const {
      setActiveHomepageCard,
      t,
      courseId,
      updateFilterObject,
    } = this.props;
    updateFilterObject({
      folderIds: undefined,
      searchText: undefined,
      duration: undefined,
      unTaggedWithFolder: undefined,
    });
    if (_.isUndefined(courseId)) {
      setActiveHomepageCard({
        from: "home-page",
        label: t(`common:portfolio`),
      });
    }
  };
  fetchMoreFeed = () => {
    const { hasNextPage, networkStatus, loadMorePosts } = this.props;
    if (hasNextPage && networkStatus != 3) {
      loadMorePosts();
    }
  };

  componentDidUpdate = prevProps => {
    prevProps.totalCount < _.get(this.props, "totalCount", 0) &&
      this.goScrollToTop();
  };

  isShowActionBar = () => {
    const { showActionBar } = this.state;
    const {
      filters,
      totalCount,
      userInfo: { user_type: userType },
      isArchivedClass,
      curriculumProgramType,
    } = this.props;
    // show action bar to approve un-approved posts only to teacher in "In Approval" tab
    return (
      userType == "staff" &&
      filters.state == "IN_APPROVAL" &&
      totalCount > 1 &&
      showActionBar &&
      !isArchivedClass &&
      (!isDPSubjectJournalEnabled(curriculumProgramType) ||
        isPortfolioParityEnabled())
    );
  };

  isShowActionBarV2 = () => {
    const {
      filters,
      userInfo: { user_type: userType },
      isArchivedClass,
      isCreateAndPublishPermissionAndHasInApproval,
    } = this.props;
    return (
      userType == "staff" &&
      filters.state == "IN_APPROVAL_STAFF" &&
      isCreateAndPublishPermissionAndHasInApproval &&
      !isArchivedClass
    );
  };

  onActionBarCloseClick = () => {
    this.setState({ showActionBar: false });
  };

  goScrollToTop = () => {
    if (this.journalFeedContainer) {
      this.journalFeedContainer.scrollTop = 0;
    }
  };

  onScroll = () => {
    if (
      this.journalFeedContainer &&
      checkScrollAtBottom(this.journalFeedContainer)
    ) {
      this.fetchMoreFeed();
    }
  };

  // Following methods are used specifically for DP journal
  onSearchChange = value => {
    const { updateFilterObject } = this.props;
    if (_.size(_.trim(value), 0) > 0) {
      updateFilterObject({ searchText: value });
    } else updateFilterObject({ searchText: undefined });
  };

  onStatusOptionClick = value => {
    const { updateFilterObject } = this.props;
    const stateValue = _.get(value, "key", undefined);
    updateFilterObject({ state: stateValue });
  };

  getCurrentStatusFilter = filters => {
    const { t } = this.props;
    const state = _.get(filters, "state");
    if (_.isUndefined(state) || _.isEqual(state, "ALL")) {
      return t("common:all");
    } else return t(`journal:${_.lowerCase(state)}`);
  };

  onTagsFilterChange = values => {
    const { tagsOptions, updateFilterObject } = this.props;
    if (_.size(values) == _.size(tagsOptions)) {
      // All is selected
      updateFilterObject({
        folderIds: undefined,
        unTaggedWithFolder: undefined,
      });
    } else {
      if (_.find(values, value => value == "unTaggedWithFolder") != undefined) {
        updateFilterObject({
          folderIds: [
            ..._.filter(values, value => value != "unTaggedWithFolder"),
          ],
          unTaggedWithFolder: true,
        });
      } else {
        updateFilterObject({
          folderIds: [
            ..._.filter(values, value => value != "unTaggedWithFolder"),
          ],
          unTaggedWithFolder: false,
        });
      }
    }
  };
  render() {
    const {
      feedList,
      networkStatus,
      onPostActionClick,
      currentCommentPostId,
      filters,
      totalCount,
      userInfo,
      t,
      folders,
      inlineContainerStyle,
      isArchivedClass,
      curriculumProgramType,
      isData,
      isLoading,
      showCommentButton,
      bulkPostsDraftOrPublishAction,
      updateFilterObject,
      onManageFolderClicked,
      selectedAcademicYearId,
      isCreateAndPublishPermissionAndHasInApproval,
    } = this.props;
    const { user_type: userType } = userInfo;

    const containerStyle = classNames(
      { [classes.container]: classes.container },
      {
        [classes.containerWithAction]:
          !!this.isShowActionBar() && !isPortfolioParityEnabled(),
      },
      {
        [classes.containerWithActionV2]:
          !!this.isShowActionBar() && isPortfolioParityEnabled(),
      },
      {
        [classes.containerWithActionV3]:
          this.isShowActionBarV2() && isPortfolioReviewSetupEnabled(),
      },
      {
        [classes.containerV2]: isPortfolioFilterRevamp(),
      }
    );

    const resetFilters = () => {
      updateFilterObject({
        folderIds: undefined,
        duration: undefined,
        searchText: undefined,
      });
    };

    const isFilterApplied = () => {
      return (
        !(
          _.isEmpty(filters.duration) ||
          _.isEmpty(_.compact(_.values(filters.duration)))
        ) ||
        !_.isEmpty(filters.searchText) ||
        !_.isEmpty(filters.folderIds)
      );
    };

    const onActionClick = () => {
      onPostActionClick({ action: "APPROVE_ALL" });
    };

    const applyInlineStyles =
      (isPortfolioParityEnabled() &&
        !_.isEqual(_.get(filters, "state", "PUBLISHED"), "IN_APPROVAL") &&
        !(
          _.isEqual(
            _.get(filters, "state", "PUBLISHED"),
            "IN_APPROVAL_STAFF"
          ) && isCreateAndPublishPermissionAndHasInApproval
        )) ||
      isPortfolioFilterRevamp();

    const hasManageAccess = canManagePortfolioActions(userType);

    return (
      <React.Fragment>
        <div
          className={containerStyle}
          style={applyInlineStyles ? inlineContainerStyle : BLANK_OBJECT}
          ref={ref => (this.journalFeedContainer = ref)}
          onScroll={this.onScroll}
        >
          {isPortfolioFilterRevamp() ? (
            <SearchWithFilters
              filters={filters}
              folders={folders}
              academicYearId={selectedAcademicYearId}
              isArchivedClass={isArchivedClass}
              onSearchChange={this.onSearchChange}
              onManageFolderClicked={onManageFolderClicked}
              updateFilterObject={updateFilterObject}
              showFolderDropDown={true}
            />
          ) : null}
          {_.get(feedList, "length", 0) > 0 || isLoading ? (
            isLoading && !isData && isPortfolioFilterRevamp() ? (
              <CardSkeletonLoader />
            ) : (
              <JournalFeedComponentWithLoader
                feedList={feedList}
                fetchMoreFeed={this.fetchMoreFeed}
                updateContainerDivRef={this.updateContainerDivRef}
                onPostActionClick={onPostActionClick}
                userInfo={userInfo}
                currentCommentPostId={currentCommentPostId}
                isArchivedClass={isArchivedClass}
                isDPFeedView={
                  isDPSubjectJournalEnabled(curriculumProgramType) ||
                  isPortfolioParityEnabled()
                }
                isData={isData}
                isLoading={isLoading}
                showCommentButton={showCommentButton}
                networkStatus={networkStatus}
                getCoursePostFeed={this.props.getCoursePostFeed}
                isStudentArchived={_.get(
                  this.props,
                  "isStudentArchived",
                  false
                )}
                isUserAllowedToPublishPost={_.get(
                  this.props,
                  "isUserAllowedToPublishPost"
                )}
                isPostCtaDisabled={_.get(
                  this.props,
                  "isPostCtaDisabled",
                  false
                )}
              />
            )
          ) : (
            <NoDataComponent
              t={t}
              filters={filters}
              userType={userType}
              reset={resetFilters}
            />
          )}
        </div>
        {!isPortfolioFilterRevamp() && !!this.isShowActionBar() && (
          <HiddenIfPreviousYear>
            <ActionBar
              totalCount={totalCount}
              onActionClick={onPostActionClick}
              onCloseClick={this.onActionBarCloseClick}
              showDesignV2={isPortfolioParityEnabled()}
            />
          </HiddenIfPreviousYear>
        )}

        {!isPortfolioFilterRevamp() && this.isShowActionBarV2() ? (
          <ActionBarV2 onActionClick={bulkPostsDraftOrPublishAction} t={t} />
        ) : null}

        {isPortfolioFilterRevamp() &&
        hasManageAccess &&
        !!this.isShowActionBar() &&
        _.get(filters, "state") === "IN_APPROVAL" &&
        !isFilterApplied() ? (
          <ApproveActionBar
            state={"IN_APPROVAL"}
            titleText={t("journal:count_posts_pending_approval", {
              count: totalCount,
            })}
            onCloseClick={this.onActionBarCloseClick}
            onActionClick={onActionClick}
            isClosable={true}
          />
        ) : null}

        {isPortfolioFilterRevamp() &&
        hasManageAccess &&
        this.isShowActionBarV2() &&
        _.get(filters, "state") === "IN_APPROVAL_STAFF" ? (
          <ApproveActionBar
            onActionClick={bulkPostsDraftOrPublishAction}
            message={t("journal:you_no_longer_have_reviewer_assigned")}
            isClosable={false}
            state={"IN_APPROVAL_STAFF"}
            alertStyle={alertStyle}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const onPusherEventTriggered = getCoursePostFeed => params => {
  switch (_.get(params, "notification_type")) {
    case "PUBLISH_SCHEDULED_POST":
      getCoursePostFeed?.refetch();
      break;
    default:
      return;
  }
};

const loadMorePosts = (query, variables) => () => {
  return query.fetchMore({
    variables,
    updateQuery: (previousResult, { fetchMoreResult }) => {
      const previousCourse = previousResult.node;
      const newCourse = fetchMoreResult.node;

      return {
        ...previousResult,
        node: {
          ...previousCourse,
          posts: {
            ...previousCourse.posts,
            pageInfo: {
              ...previousCourse.posts.pageInfo,
              ...newCourse.posts.pageInfo,
            },
            edges: [...previousCourse.posts.edges, ...newCourse.posts.edges],
          },
        },
      };
    },
  });
};

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const selectedAcademicYear = _.get(
    state,
    "platform.academicYearSelected",
    {}
  );
  const curriculumProgramType = state.platform.currentCurriculumProgram.type;
  const fieldUids = getFieldUidsMemoize({ curriculumProgramType });
  // Specifically for DP journal tags filter

  const translationFilter = getPostTranslationFilter({
    userInfo,
    shouldTranslate: false,
    handleTranslation: hasTranslationPermission(),
  });

  const userType = userInfo.user_type;
  const showCommentButton =
    userType === "staff" ||
    getSettingValue({
      name:
        userType === "parent"
          ? "enableFamilyCommentCreation"
          : "EnableCommentingOnPostByStudents",
      courseId: _.get(state, "teacher.selected_class.selected_course"),
      organizationId: userInfo.org_id,
      userId: userInfo.id,
      userEntityType: userInfo.userEntityType,
    });

  const updateFiltersObject = filters => {
    let updatedFilters = filters;
    if (updatedFilters?.state === "IN_APPROVAL_STAFF") {
      updatedFilters = {
        ...updatedFilters,
        state: "IN_APPROVAL",
      };
    }
    return updatedFilters;
  };
  const getReviewerPostFilters = filters => {
    const { state, ...filterWithoutState } = filters;
    if (
      userType === "staff" &&
      (state === "IN_APPROVAL_STAFF" || state === "IN_APPROVAL")
    ) {
      return {
        ...(filters.state === "IN_APPROVAL_STAFF"
          ? filterWithoutState
          : filters),
        ...(state === "IN_APPROVAL_STAFF"
          ? {
              states:
                filters.state === "IN_APPROVAL_STAFF"
                  ? ["IN_APPROVAL", "REJECTED"]
                  : filters.state,
            }
          : {}),
        ...((filters.state === "IN_APPROVAL" ||
          filters.state === "IN_APPROVAL_STAFF") && {
          creatorType:
            userType === "staff" && filters.state === "IN_APPROVAL_STAFF"
              ? "staff"
              : "student",
        }),
        ...(filters.state === "IN_APPROVAL_STAFF" && {
          createdBy: userInfo.id,
        }),
      };
    }
    return filters;
  };

  const allFilters = isPortfolioReviewSetupEnabledAndIsJournalRoute()
    ? updateFiltersObject(
        getReviewerPostFilters(_.get(state, "journal.filters"))
      )
    : _.get(state, "journal.filters");

  const filtersForPostFeedQuery = getPostFeedFiltersMemoized({
    userType,
    filters: {
      ...allFilters,
      duration:
        isPortfolioFilterRevamp() && !_.isNil(allFilters.duration)
          ? {
              fromDate: !_.isNull(allFilters?.duration?.fromDate)
                ? moment(
                    allFilters?.duration?.fromDate?.format("YYYY-MM-DD")
                  )?.toISOString()
                : null,
              toDate: !_.isNull(allFilters?.duration?.toDate)
                ? moment(allFilters?.duration?.toDate?.format("YYYY-MM-DD"))
                    ?.add({ hours: 23, minutes: 59 })
                    ?.toISOString()
                : null,
            }
          : undefined,
    },
    userId: userInfo.id,
  });
  return {
    userInfo,
    selectedAcademicYearId: _.get(selectedAcademicYear, "id", ""),
    fieldUids,
    translationFilter,
    curriculumProgramType,
    tagsOptions: getTagsMemoized({ tagsFromProps: ownProps?.folders }),
    showCommentButton,
    filtersForPostFeedQuery,
  };
};

const mapActionCreators = {
  setActiveHomepageCard,
  bulkPostsDraftOrPublishAction,
};

const shouldSkipFeedQuery = props => {
  const { courseId, filtersForPostFeedQuery, userInfo } = props;
  const userType = _.get(userInfo, "user_type");

  // skip for parent if studentIds is empty or showPrivate is true
  const invalidForParent =
    userType === "parent" &&
    (_.isEmpty(filtersForPostFeedQuery?.studentIds) ||
      filtersForPostFeedQuery?.showPrivate);

  return _.isNil(courseId) || _.isEmpty(courseId) || invalidForParent;
};
export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["journal", "common"] }),
  graphql(getCoursePostFeedQuery, {
    name: "getCoursePostFeed",
    skip: shouldSkipFeedQuery,
    options: ({
      courseId,
      filtersForPostFeedQuery,
      fieldUids,
      translationFilter,
      curriculumProgramType,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        filters: filtersForPostFeedQuery,
        uids: fieldUids,
        translationFilter: translationFilter,
        isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
      },
    }),
    props({
      getCoursePostFeed,
      ownProps: {
        courseId,
        filtersForPostFeedQuery,
        fieldUids,
        translationFilter,
        curriculumProgramType,
      },
    }) {
      const course = getCourseJournalFeedFromCache({
        courseId,
        filters: filtersForPostFeedQuery,
        uids: fieldUids,
        translationFilter,
        isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
      });
      const postObject = _.get(getCoursePostFeed, "node.posts", {});
      const pageInfo = _.get(postObject, "pageInfo", {});
      return {
        getCoursePostFeed,
        hasNextPage: _.get(pageInfo, "hasNextPage", false),
        feedList: _.get(postObject, "edges", []),
        isData: !_.isEmpty(course),
        onPusherEventTriggered: onPusherEventTriggered(getCoursePostFeed),
        networkStatus: getCoursePostFeed.networkStatus,
        totalCount: _.get(postObject, "totalCount", 0),
        isLoading:
          getCoursePostFeed["networkStatus"] == 1 ||
          getCoursePostFeed["networkStatus"] == 2,
        loadMorePosts: loadMorePosts(getCoursePostFeed, {
          filters: filtersForPostFeedQuery,
          after: _.get(pageInfo, "endCursor", null),
          id: courseId,
          uids: fieldUids,
          translationFilter: translationFilter,
          isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
        }),
      };
    },
  }),
  graphql(getParentJournalFeedQuery, {
    name: "getParentJournalFeed",
    skip: ({ parentId }) => !parentId,
    options: ({ parentId, filters, selectedAcademicYearId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: parentId,
        filters: {
          ...filters,
          academicYears: [selectedAcademicYearId],
        },
      },
    }),
    props({
      getParentJournalFeed,
      ownProps: { filters, parentId, selectedAcademicYearId },
    }) {
      const modifiedFilters = {
        ...filters,
        academicYears: [selectedAcademicYearId],
      };
      const postFromCache = getParentJournalFeedFromCache({
        filters: modifiedFilters,
        parentId,
      });
      const postObject = _.get(getParentJournalFeed, "node.posts", {});
      const pageInfo = _.get(postObject, "pageInfo", {});
      return {
        getParentJournalFeed,
        hasNextPage: _.get(pageInfo, "hasNextPage", false),
        feedList: _.get(postObject, "edges", []),
        isData: !_.isEmpty(postFromCache),
        networkStatus: getParentJournalFeed.networkStatus,
        totalCount: _.get(postObject, "totalCount", 0),
        isLoading:
          getParentJournalFeed["networkStatus"] == 1 ||
          getParentJournalFeed["networkStatus"] == 2,
        loadMorePosts: loadMorePosts(getParentJournalFeed, {
          filters: modifiedFilters,
          after: _.get(pageInfo, "endCursor", null),
          id: parentId,
        }),
      };
    },
  }),
  withPusherBind(["publishScheduledJournalPostRealtime"])
)(JournalFeed);
JournalFeed.displayName = "JournalFeed";
